/**
 * author Remy Sharp
 * url http://remysharp.com/2009/01/26/element-in-view-event-plugin/
 */
(function ($) {
		function getViewportHeight() {
				var height = window.innerHeight; // Safari, Opera
				var mode = document.compatMode;

				if ( (mode || !$.support.boxModel) ) { // IE, Gecko
						height = (mode == 'CSS1Compat') ?
						document.documentElement.clientHeight : // Standards
						document.body.clientHeight; // Quirks
				}

				return height;
		}

		$(window).scroll(function () {
				var vpH = getViewportHeight(),
						scrolltop = (document.documentElement.scrollTop ?
								document.documentElement.scrollTop :
								document.body.scrollTop),
						elems = [];
				
				// naughty, but this is how it knows which elements to check for
				$.each($.cache, function () {
						if (this.events && this.events.inview) {
								elems.push(this.handle.elem);
						}
				});

				if (elems.length) {
						$(elems).each(function () {
								var $el = $(this),
										top = $el.offset().top,
										height = $el.height(),
										inview = $el.data('inview') || false;

								if (scrolltop > (top + height) || scrolltop + vpH < top) {
										if (inview) {
												$el.data('inview', false);
												$el.trigger('inview', [ false ]);                        
										}
								} else if (scrolltop < (top + height)) {
										if (!inview) {
												$el.data('inview', true);
												$el.trigger('inview', [ true ]);
										}
								}
						});
				}
		});
		
		// kick the event to pick up any elements already in view.
		// note however, this only works if the plugin is included after the elements are bound to 'inview'
		$(function () {
				$(window).scroll();
		});
})(jQuery);

/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

		// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	 // Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen flex-video'/>");
		} else {
			jQuery(this).wrap("<div class='flex-video'/>");
		}
	});

});

(function( root, $, undefined ) {
	"use strict";


	// $(function() {
	//   $('a[href*="#"]:not([href="#"])').click(function() {
	//     if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
	//       var target = $(this.hash);
	//       target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
	//       if (target.length) {
	//         $('html, body').animate({
	//           scrollTop: target.offset().top
	//         }, 1000);
	//         return false;
	//       }
	//     }
	//   });
	// });

	$(document).ready(function(){
		setTimeout( function(){$('.js-fixed-button').addClass('show');} , 7000);
	});


	$(function () {

			$('.js-menu-toggle').click(function(e){

				e.preventDefault();
				
				if($('body').hasClass('is-menu-active')){

					$('body').removeClass('is-menu-active');

				} else {    

					$('body').addClass('is-menu-active');  

				}
			});


			$(document).ready(function(){
					$('.js-fieldset').bind('inview', function (event, visible) {
						if (visible === true) {
							// element is now visible in the viewport
							$(this).addClass('focus');
						} else {
							// element has gone out of viewport
							 $(this).removeClass('focus');
						}
					});
			});

	});


		var formvalid = true,
				fieldmessage = '';

		function validateEmail($email) {
			var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
			return emailReg.test( $email );
		}

		function validateField($field, $minlength, $fieldname, fieldmessage){
			var fieldvalid = true;
			$field.parent('.form__field').removeClass('error');
			$field.next('.errormessage').empty();

			if(!$field.val()) {          
					fieldvalid = false;
					fieldmessage += '<span>' + $fieldname + '\n' + ' is missing.</span> ';
					$field.parent('.form__field').addClass('error');
			}

			if($field.val().length < $minlength){
					fieldvalid = false;
					fieldmessage += '<span>' + $fieldname + '\n' + ' must be a minimum of ' + $minlength + ' characters</span>. ';
					$field.parent('.form__field').addClass('error');                
			}     

			if(fieldvalid) {
					$field.parent('.form__field').addClass('valid');
			} else {
					formvalid = false;
					$field.next('.errormessage').append(fieldmessage);
			}
			return formvalid;     
		}

		function formValidate($form){

				var form = $form,
						formdata = form.serialize(),
						requiredFields = $('.required', form),
						emailAddress = $('.email').val();

				requiredFields.each(function() {
						var $this = $(this),      
								minlength = $this.attr('data-minlength'),
								inputName = $this.attr('data-name');

						validateField($this, minlength, inputName, fieldmessage);
				});

				if( !validateEmail(emailAddress)) {        
						formvalid = false;
						$('.email').next('.errormessage').append('Please enter a valid email address');
						$('.email').parent('.form__field').removeClass('valid').addClass('error');
				}

				if(!formvalid) {
						$('.response').html('Your form has errors.');
						$('.responsewrap').addClass('active');     
				} else {       
						var action = 'form_handler';

						$('.loader').addClass('active');
						$('.responsewrap').removeClass('active');

						if($form.hasClass('form--contact')) {
							action = 'form_handler_customer';
						}

						var posting = $.post(ajaxurl, {'data':formdata,'action': action});            

						posting.done(function(data) {

								console.log(data);
								if(data=="success") {            
										$('body').addClass('modal-open');
								} else {
										$('.loader').removeClass('active');
										$('.response').html(data);
										$('.responsewrap').addClass('active');                         
								}

						});
				}
		}


	$('.js-validate').submit(function(e) {
			e.preventDefault();
			formvalid = true;
			formValidate($(this));   
	});

	$('.js-validate .required').blur(function() {
			var $this = $(this),      
					minlength = $this.attr('data-minlength'),
					inputName = $this.attr('data-name');

			validateField($this, minlength, inputName, fieldmessage); 
	});

	$('.js-validate .email').blur(function() {
			var emailAddress = $(this).val();

			if(!emailAddress) {          
					formvalid = false;
					$(this).next('.errormessage').append('Email is missing.');
					$(this).parent('.form__field').addClass('error');
			}

			if( !validateEmail(emailAddress)) {        
					formvalid = false;
					$(this).next('.errormessage').append('Please enter a valid email address');
					$(this).parent('.form__field').removeClass('valid').addClass('error');
			}

	});   


	$('.js-modal-close').click(function(){
		var $body = $('body');

		$body.addClass('modal-close');
		setTimeout(function(){
			$body.removeClass('modal-open');
		}, 1500);
		$('.js-hero-video').empty();
		$('.loader').removeClass('active');
	});

	$(document).ready(function(){
		$('#whoson_chat_link').css('display', 'none');
	});

	// $(window).load(function(){
	// 	var chaturl = '';
	// 	if('#whoson_chat_link'){
	// 		chaturl = $('#whoson_chat_link').attr('href');
	// 	}
	// 	if(chaturl){      
	// 		$('.js-chat').attr('href', chaturl).attr('target', '_blank');
	// 	} else {
	// 		$('.js-chathide').hide();
	// 	}
	// });
	$(window).load(function(){
		var chaturl = '';
		if('#whoson_chat_link'){
			var windowFeatures = "menubar=no,location=yes,resizable=yes,scrollbars=yes,status=yes,innerHeight=530,innerWidth=420";
			chaturl = $('#whoson_chat_link').attr('href');
			// chaturl = 'https://hosted4.whoson.com/chat/chatstart.htm?domain=www.shippo.co.uk&timestamp=1480074213300&session=751-1480074213296';
			var fullurl = 'window.open("' + chaturl + '", "WhosOn Chat","' + windowFeatures + '");';
			console.log(fullurl);
		}
		if(chaturl){      
			// $('.js-chat').attr('onclick', fullurl).attr('href', 'javascript:;');
			$('.js-chat').click(function(e) {
				e.preventDefault();
				window.open(chaturl,"WhosOn Chat",windowFeatures);
				e.stopPropagation();
			});
		} else {
			$('.js-chathide').hide();
		}
	});



	$('.js-video-modal').click(function(e){

		e.preventDefault();

		var video__frame = '<iframe width="560" height="315" class="thevideo" src="https://www.youtube.com/embed/' + videoID + '?rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>',
				$body = $('body');
		
		if($body.hasClass('modal-open')){

			$body.addClass('modal-close');
			setTimeout(function(){
				$body.removeClass('modal-open');
			}, 1500);      
			$('.js-hero-video').empty();

		} else {    
			
			$('.js-hero-video').html(video__frame);
			if ($('.thevideo')){
				$body.removeClass('modal-close');
				$body.addClass('modal-open');
			}

		}


	});




  /**
   * Squaredaisy Custom Elements
   * Shipping Calculator & Comparison Card
   */
  $('#js-dutycalc').submit(function(e) {


    e.preventDefault();
    e.stopImmediatePropagation();

    var comVal = parseInt($( "#Question29" ).val());
    var shipCosts = parseInt($( "#Question30" ).val());
    var UKduty = parseFloat($( "#Question31" ).val());

    if(!isNaN(UKduty)){
      UKduty /= 100;
      UKduty = UKduty;
    }

    var hiddenDuty = ((comVal + shipCosts) * UKduty);
    var Initialresult = 0.2 * ((UKduty * (comVal + shipCosts)) + shipCosts + comVal) + UKduty * (comVal + shipCosts);
    var result = Math.round(Initialresult ).toFixed(2);

    if(!isNaN(result)){
      $( "h3.result span" ).empty();
      $( "h3.result span" ).append( result );

    } else {
      alert("Please enter all values, as whole numbers without symbols.");
    }

  });

  $('#js-insurcalc').submit(function(e) {

    e.preventDefault();
    e.stopImmediatePropagation();

    var commVal = parseInt($("#commVal").val());
    var shipCost = parseInt($("#shipCost").val());

    var insurRate = (commVal + shipCost) * 0.00495;
    var result = (insurRate < 35) ? 35 :  Math.round(insurRate);

    if (!isNaN(result)) {
      $("h3.result span").empty();
      $("h3.result span").append(result.toFixed());
    } else {
      alert("Please enter all values, as whole numbers without symbols.");
    }
  });

  $('#js-deliverycalc').submit(function(e) {

    $("h3#delivery-result.result span").empty();
    e.preventDefault();
    e.stopImmediatePropagation();

    var obPort = $("#obPort").val();
    var readyDate = new Date( $("#readyDate").val() );
    var azFBA = $("#azFBA").val();

    var getNextMonday = function(date){
      var nm = new Date(date);
      nm.setDate(readyDate.getDate() + (7 + 1 - readyDate.getDay()) % 7);
      return (readyDate.getDate() === nm.getDate())
        ? nm = new Date(nm.setDate( nm.getDate() + 7 ))
        : nm;
    };

    var nextMonday = getNextMonday(readyDate);

    var addDestinationDays = function(dest){
      switch (dest) {
        case 'Shenzhen':
        case 'Guangzhou':
        case 'Hong Kong':
          return 38;
        case 'Shanghai':
        case 'Ningbo':
          return 45;
        case 'Tianjin/Xingang':
        case 'Qingdao':
          return 52;
      }
    };

    var addedDays = addDestinationDays(obPort);

    var totalDays = function(){
      var deliveryDate;

      if(azFBA === 'yes'){
        deliveryDate = new Date(nextMonday.setDate( nextMonday.getDate() + addedDays + 3))
      } else {
        deliveryDate = new Date(nextMonday.setDate( nextMonday.getDate() + addedDays ))
      }
      console.log();
      if(deliveryDate.getDay() === 6) {
        deliveryDate = new Date(deliveryDate.setDate(deliveryDate.getDate() + 2))
      } else if(deliveryDate.getDay() === 0) {
        deliveryDate = new Date(deliveryDate.setDate(deliveryDate.getDate() + 1))
      }

      return deliveryDate.toLocaleDateString('en-GB', {weekday: 'long',  year: 'numeric', month: 'long', day: 'numeric' });
    };

    $("h3#delivery-result.result span").append(totalDays())

  });

  var cc = $('.comparison-card');

  $('.comparison-card--detail--graph').each(function () {
    console.log($(this))
  })

  function setBarLengths() {
    $('.comparison-card--detail--graph--bar').each(function () {
      if ( cc.hasClass('front') ) {
        $(this).css('width', $(this)[0].dataset.front + '%')
      }
      else if ( cc.hasClass('back') ){
        $(this).css('width', $(this)[0].dataset.back + '%')
      }
    })
  }

  $('.comparison-card--detail--h').click(function(e){
    var target = e.target.dataset.target;
    if ( target === "front" ) {
      cc.removeClass('back');
      cc.addClass('front');
      setBarLengths()
    }
    else if ( target === "back" ) {
      cc.removeClass('front');
      cc.addClass('back');
      setBarLengths()
    }
  });

  setTimeout(function(){
    setBarLengths()
  }, 1000)



} ( this, jQuery ));